import type { ReactNode } from "react";

import { cn } from "../../../lib/utils";
import { SkeletonText } from "./SkeletonText";

export function SkeletonCard({
  children,
  className,
  testId,
}: {
  children?: ReactNode;
  className?: string;
  testId?: string;
}) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "rounded-2xl border border-border bg-card p-4 shadow-sm",
        className,
      )}
      data-testid={testId}
    >
      {children ?? <SkeletonText lines={3} />}
    </div>
  );
}
